import { render, staticRenderFns } from "./ReferralsBlockPhase.vue?vue&type=template&id=0d12fcc7&"
import script from "./ReferralsBlockPhase.vue?vue&type=script&lang=ts&"
export * from "./ReferralsBlockPhase.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralsBlockPhase.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports